export enum ModeIntervenant {
  ENTREPRISE = 'ENTREPRISE',
  COMPAGNON = 'COMPAGNON',
}
